import type { ColDef } from 'ag-grid-community';
import dateFormatter from '../../components/valueFormatter/dateFormatter';

const colDef: ColDef[] = [
  {
    headerName: '',
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    checkboxSelection: true,
    resizable: false,
    suppressMenu: true,
    suppressSizeToFit: true,
    width: 45,
  },
  {
    headerName: '鉄鋼メーカー',
    headerTooltip: '鉄鋼メーカー',
    field: 'メーカー名',
    tooltipField: 'メーカー名',
    width: 70,
  },
  {
    headerName: 'ミル',
    headerTooltip: 'ミル',
    field: 'ミル情報',
    tooltipField: 'ミル情報',
    width: 60,
  },
  {
    headerName: '品種',
    headerTooltip: '品種',
    field: '品種',
    tooltipField: '品種',
    width: 60,
  },
  {
    headerName: '店部課',
    headerTooltip: '店部課',
    field: '商社店部課名',
    tooltipField: '商社店部課名',
    width: 60,
  },
  {
    headerName: '契約番号',
    headerTooltip: '契約番号',
    field: '契約番号_表示',
    tooltipField: '契約番号_表示',
    width: 125,
  },
  {
    headerName: '規格',
    headerTooltip: '規格',
    field: '規格',
    tooltipField: '規格',
    width: 125,
  },
  {
    headerName: '寸法',
    headerTooltip: '寸法',
    field: '寸法_表示',
    tooltipField: '寸法_表示',
    width: 70,
    cellClass: 'cell',
  },
  {
    headerName: '溶解番号',
    headerTooltip: '溶解番号',
    field: '溶解番号_表示',
    tooltipField: '溶解番号_表示',
    width: 100,
  },
  {
    headerName: '検査番号',
    headerTooltip: '検査番号',
    field: '検査番号',
    tooltipField: '検査番号',
    width: 100,
  },
  {
    headerName: '納入状態',
    headerTooltip: '納入状態',
    field: '納入状態',
    tooltipField: '納入状態',
    width: 70,
  },
  {
    headerName: '需要家1',
    headerTooltip: '需要家1',
    field: '需要家1',
    tooltipField: '需要家1',
  },
  {
    headerName: '需要家2',
    headerTooltip: '需要家2',
    field: '需要家2',
    tooltipField: '需要家2',
  },
  {
    headerName: '需要家3',
    headerTooltip: '需要家3',
    field: '需要家3',
    tooltipField: '需要家3',
  },
  {
    headerName: '発行年月日',
    headerTooltip: '発行年月日',
    field: '証明書発行年月日',
    tooltipField: '証明書発行年月日',
    valueFormatter: dateFormatter,
    width: 125,
  },
  {
    headerName: '証明書番号',
    headerTooltip: '証明書番号',
    field: '証明書番号',
    tooltipField: '証明書番号',
    width: 125,
  },
  {
    headerName: '需要家1',
    headerTooltip: '需要家1',
    field: '需要家コード1',
    tooltipField: '需要家コード1',
    width: 75,
  },
  {
    headerName: '需要家2',
    headerTooltip: '需要家2',
    field: '需要家コード2',
    tooltipField: '需要家コード2',
    width: 75,
  },
  {
    headerName: '需要家3',
    headerTooltip: '需要家3',
    field: '需要家コード3',
    tooltipField: '需要家コード3',
    width: 75,
  },
  {
    headerName: '受渡場所',
    headerTooltip: '受渡場所',
    field: '受渡場所コード',
    tooltipField: '受渡場所コード',
    width: 75,
  },
  {
    headerName: '受渡場所名',
    headerTooltip: '受渡場所名',
    field: '受渡場所名',
    tooltipField: '受渡場所名',
    cellRenderer: 'deliveryLocationCellRenderer',
    width: 75,
  },
  {
    headerName: '商社',
    headerTooltip: '商社',
    field: '商社名',
    tooltipField: '商社名',
    width: 70,
  },
];

export default colDef;
